import {
  Box,
  Button,
  Chip,
  Divider,
  FormControl,
  FormLabel,
  Stack,
} from "@mui/material";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import {Grid} from "@mui/system";
import style from "../../../assets/css/proposal.module.scss";
import GlobalTextField from "../../global-fields/GlobalTextField";
import {useFormik} from "formik";
import * as Yup from "yup";
import NewProposalFooter from "./NewProposalFooter";
import {MANDATORY_QUES} from "../../../constants/constants";
import {useDispatch, useSelector} from "react-redux";
import {selectAuthState, setAuthData} from "../../../store/authSlice";
import {selectDataStoreState, setDataStore} from "../../../store/dataSlice";
import {PROPOSAL_FORM} from "../../../constants/apiConstant";
import plusIcon from "../../../assets/img/proposal-img/plus_icon.svg";

import {
  areRequiredFieldsFilled,
  initialFormValidations,
  removeCookies,
} from "../../../constants/helper";
import GlobalNotificationPopup from "../../global-fields/GlobalNotificationPopup";
import {setUiData} from "../../../store/uiSlice";
import {useNavigate} from "react-router-dom";
import {motion} from "framer-motion";
import {fadeSlideIn} from "../../../constants/motionConstants";
import {numberSchemaWithPercentage} from "../../../constants/validationSchemas";
import GlobalYearMonthField from "../../global-fields/GlobalYearMonthField";
import dayjs from "dayjs";
import GlobalMultiTextField from "../../global-fields/GlobalMultiTextField";
import {IoIosClose} from "react-icons/io";

const maxValues = 20; // Limit to 20 values

const StepOneForm = ({leftGridWidth}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {user, selectedClient} = useSelector(selectAuthState);
  const {
    proposal_id,
    proposalStep,
    propStep1Data,
    previous_proposal_id,
    editingSubmitted,
    formValidations,
    jewelers_block_type,
  } = useSelector(selectDataStoreState);
  const [disableDraft, setDisableDraft] = useState(false);

  const handleStepData = (e) => {
    // console.log("Touched:", formik.touched);
    // console.log("Data saved:", formik.values);

    // return;
    dispatch(
      setUiData({
        showLoader: true,
      })
    );

    let data = {
      ...e,
      user_id: user?.id,
      step: proposalStep,
      jewelers_block_type: previous_proposal_id ? null : jewelers_block_type,
      proposal_id: previous_proposal_id ? null : (proposal_id ?? null),
      proposal_status: editingSubmitted ? 1 : 0,
      previous_proposal_id: previous_proposal_id ?? null,
      business_duration: e.business_duration
        ? dayjs(e.business_duration).format("MMMM YYYY")
        : "",
      elsewhere_duration: e.elsewhere_duration
        ? dayjs(e.elsewhere_duration).format("MMMM YYYY")
        : "",
    };
    if (user?.user_type === "agent") {
      data = {...data, user_id: selectedClient?.user_id, agent_id: user?.id};
    }

    const options = {
      method: PROPOSAL_FORM.method,
      headers: PROPOSAL_FORM.headers,
      body: JSON.stringify(data),
    };

    fetch(PROPOSAL_FORM.url, options)
      .then((response) => response.json())
      .then((res) => {
        if (res.status == 0) {
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
          // GlobalNotificationPopup({ type: "error", message: res?.message });
          // removeCookies("isLogin");
          formik.resetForm();
        } else if (res.status == 1) {
          // GlobalNotificationPopup({ type: "success", message: res?.message });
          // dispatch(
          //   setAuthData({
          //     user_id: res?.user_id,
          //   })
          // );
          formik.resetForm();

          dispatch(
            setDataStore({
              proposalStep: proposalStep + 1,
              proposal_id: res?.proposal_id ? res?.proposal_id : null,
              formValidations: res?.step_status ?? initialFormValidations,
              // jewelers_block_type: 0,
            })
          );
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
          // setCookies("isLogin", "true");
          // navigate(`/login`);
        }
        if (e?.save_draft) {
          setDisableDraft(false);
        }
      })
      .catch((error) => {
        removeCookies("isLogin");
        GlobalNotificationPopup({type: "error", message: error});
        console.log("error", error);
        dispatch(
          setUiData({
            showLoader: false,
          })
        );
        navigate("/");
        formik.resetForm();
      });
  };

  const propStep1DataMemoize = useMemo(
    () => (propStep1Data ? propStep1Data : null),
    [propStep1Data]
  );
  const initialValues = {
    step: 1,
    firm_name:
      propStep1DataMemoize?.firm_name ??
      (user?.user_type !== "agent" ? user?.company : selectedClient?.company) ??
      null,
    owner_name:
      propStep1DataMemoize?.owner_name?.length > 0
        ? propStep1DataMemoize?.owner_name
        : [],
    // officer_name:
    //   propStep1DataMemoize?.officer_name?.length > 0
    //     ? propStep1DataMemoize?.officer_name
    //     : [],
    street:
      propStep1DataMemoize?.street ??
      (user?.user_type !== "agent"
        ? user?.address1
        : selectedClient?.address1) ??
      null,
    suite:
      propStep1DataMemoize?.suite ??
      (user?.user_type !== "agent"
        ? user?.address2
        : selectedClient?.address2) ??
      null,
    city:
      propStep1DataMemoize?.city ??
      (user?.user_type !== "agent" ? user?.city : selectedClient?.city) ??
      null,
    state:
      propStep1DataMemoize?.state ??
      (user?.user_type !== "agent" ? user?.state : selectedClient?.state) ??
      null,
    zip_code:
      propStep1DataMemoize?.zip_code ??
      (user?.user_type !== "agent" ? user?.zipcode : selectedClient?.zipcode) ??
      null,

    additional_addresses: propStep1DataMemoize?.additional_addresses ?? [],
    business_duration: propStep1DataMemoize?.business_duration ?? "",
    elsewhere_duration: propStep1DataMemoize?.elsewhere_duration ?? "",
    manufacturing:
      propStep1DataMemoize?.manufacturing == 0
        ? "0"
        : propStep1DataMemoize?.manufacturing
          ? propStep1DataMemoize?.manufacturing.toString()
          : null,
    retail:
      propStep1DataMemoize?.retail == 0
        ? "0"
        : propStep1DataMemoize?.retail
          ? propStep1DataMemoize?.retail.toString()
          : null,
    wholesale:
      propStep1DataMemoize?.wholesale == 0
        ? "0"
        : propStep1DataMemoize?.wholesale
          ? propStep1DataMemoize?.wholesale.toString()
          : null,
    pawnbroking:
      propStep1DataMemoize?.pawnbroking == 0
        ? "0"
        : propStep1DataMemoize?.pawnbroking
          ? propStep1DataMemoize?.pawnbroking.toString()
          : null,
    no_of_employees: propStep1DataMemoize?.no_of_employees ?? 0,
    office_hours: propStep1DataMemoize?.office_hours ?? 0,
  };
  // useEffect(() => {
  //   if (propStep1DataMemoize) {
  //     formik.setValues(initialValues);
  //   }
  // }, [propStep1DataMemoize]);
  // console.log("propStep1DataMemoize", propStep1DataMemoize, user, initialValues)


  const additionalAddressValidation = Yup.object().shape({
    street: Yup.string().required(MANDATORY_QUES),

    suite: Yup.string().notRequired(),

    city: Yup.string()
      .required(MANDATORY_QUES)
      .matches(
        /^[A-Za-z\s]+$/,
        "Enter a valid city name (Alphabets only)."
      ),

    state: Yup.string()
      .required(MANDATORY_QUES)
      .matches(
        /^[A-Za-z\s]+$/,
        "Enter a valid state name (Alphabets only)."
      ),

    zip_code: Yup.string()
      .required(MANDATORY_QUES)
      .matches(
        /^\d{5}(-\d{4})?$/,
        "Enter a valid US zip code (e.g., 12345 or 12345-6789)."
      ),
  });


  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: Yup.object({
      // firm_name: Yup.string().required(MANDATORY_QUES).matches(
      //   /^(?! )[A-Za-z.\-&\s]+$/,
      //   "Firm name must only contain letters, periods, hyphens, ampersands, and must not start with a space."
      // ),
      // firm_name: Yup.string()
      //   .required(MANDATORY_QUES)
      //   .matches(
      //     // /^(?! )[A-Za-z0-9.\-&\s]+$/,
      //     /^(?! )[A-Za-z0-9.\-&\s]*[A-Za-z.\-&][A-Za-z0-9.\-&\s]*$/,
      //     "Firm name may include letters, numbers, periods, hyphens, ampersands, and spaces, but must not start with a space."
      //   ),
      // firm_name: Yup.string()
      //   .required(MANDATORY_QUES)
      //   .matches(
      //     /^(?! )[A-Za-z0-9.\-&,\/\s]*[A-Za-z.\-&,\/][A-Za-z0-9.\-&,\/\s]*$/,
      //     "Firm name may include letters, numbers, periods, hyphens, ampersands, commas, slashes, and spaces—but must not start with a space."
      //   ),
      firm_name: Yup.string()
        .required(MANDATORY_QUES)
        .matches(
          /^(?! )[A-Za-z0-9.\-&,\/'\s]*[A-Za-z.\-&,\/'][A-Za-z0-9.\-&,\/'\s]*$/,
          "Firm name may include letters, numbers, periods, hyphens, ampersands, commas, apostrophes, slashes, and spaces—but must not start with a space."
        ),
      owner_name: Yup.array()
        .of(Yup.string())
        // .min(1, MANDATORY_QUES)
        .notRequired(),
      //officer_name: Yup.array()
      //.of(Yup.string())
      // .min(1, MANDATORY_QUES)
      //.notRequired(),
      // owner_name: Yup.array().required(MANDATORY_QUES),
      // officer_name: Yup.array().required(MANDATORY_QUES),

      street: Yup.string().required(MANDATORY_QUES),
      suite: Yup.string().notRequired(),
      city: Yup.string()
        .required(MANDATORY_QUES)
        .matches(/^[A-Za-z\s]+$/, "Enter a valid city name (Alphabets only)."),
      state: Yup.string()
        .required(MANDATORY_QUES)
        .matches(/^[A-Za-z\s]+$/, "Enter a valid state name (Alphabets only)."),
      zip_code: Yup.string()
        // .transform((value) => (value === "" ? null : value))
        .required(MANDATORY_QUES)
        .matches(
          /^\d{5}(-\d{4})?$/,
          "Enter a valid US zip code (e.g., 12345 or 12345-6789)."
        ),
      additional_addresses: Yup.array().of(additionalAddressValidation),
      business_duration: Yup.string().notRequired(),
      elsewhere_duration: Yup.string().notRequired(),
      // business_duration: Yup.number()
      //   .required(MANDATORY_QUES)
      //   .integer("Must be an integer")
      //   .min(1, "Minimum 1 Month.")
      //   .max(2400, "Maximum 2400 Months i.e. 200 Years."),
      // elsewhere_duration: Yup.number()
      //   .required(MANDATORY_QUES)
      //   .integer("Must be an integer")
      //   // .min(1, "Minimum 1 Month.")
      //   .max(2400, "Maximum 2400 Months i.e. 200 Years."),
      manufacturing: numberSchemaWithPercentage,
      retail: numberSchemaWithPercentage,
      wholesale: numberSchemaWithPercentage,
      pawnbroking: numberSchemaWithPercentage,
      no_of_employees: Yup.number()
        .required(MANDATORY_QUES)
        .positive("Number of employees must be a positive number!")
        .integer("Number of employees must be an integer!")
        .min(0, "Minimum number of employee is 0"),
      // .max(10000,"Maximum number of employee is 10,000"),
      office_hours: Yup.number()
        .required(MANDATORY_QUES)
        .positive("Number of employees on site must be a positive number!")
        .integer("Number of employees on site must be an integer!")
        .min(0, "Minimum number of employee is 0"),
      // .max(10000,"Maximum number of employee is 10,000"),
    }),
    onSubmit: (values) => {
      // Handle form submission
      const {manufacturing, retail, wholesale, pawnbroking} = values;
      const totEqualTo100 =
        Number(manufacturing || 0) +
          Number(retail || 0) +
          Number(wholesale || 0) +
          Number(pawnbroking || 0) ==
        100;

      //  console.log("A", manufacturing, retail, wholesale, pawnbroking, totEqualTo100)

      if (totEqualTo100) {
        //console.log("Form submitted 1:", values);
        handleStepData(values);
      } else {
        GlobalNotificationPopup({
          type: "error",
          message:
            "Total percentage of Manufacturing, Retail, Wholesale, and Pawnbroking together can't exceed or less than 100%",
        });
      }
    },
  });

  // console.log("propStep1DataMemoize", propStep1DataMemoize, initialValues)
  // console.log("previous_proposal_id",previous_proposal_id,formik.values,areRequiredFieldsFilled(formik));
  const handleCustomSubmit = async (e) => {
    const errors = await formik.validateForm();

    if (Object.keys(errors).length > 0) {
      const updated = formValidations.map((item) => {
        if (item.step === 1) {
          return {...item, status: 2};
        }
        return item;
      });

      dispatch(
        setDataStore({
          formValidations: updated,
        })
      );

      formik.handleSubmit(); // still runs to show errors
    } else {
      formik.handleSubmit(); // successful submit
    }
  };

  const handleValidationFailure = (errors) => {
    GlobalNotificationPopup({
      type: "error",
      message: "Please fix the form errors before submitting.",
    });
  };

  const handleSaveDraft = useCallback(() => {
    const {values} = formik;
    setDisableDraft(true);
    let vals = {...values, save_draft: true};
    // console.log("vals", vals);
    //return;
    handleStepData(vals);
  }, [formik]);

  const handleMultipleAddress = () => {
  formik.setFieldValue("additional_addresses", [
    ...formik.values.additional_addresses,
    {
      street: "",
      suite: "",
      city: "",
      state: "",
      zip_code: "",
    },
  ]);
};

const removeAddress = (index) => {
  const addresses = [...formik.values.additional_addresses];
  addresses.splice(index, 1);

  formik.setFieldValue("additional_addresses", addresses);
};

  return (
    <>
      <section className={style.proposalMain}>
        <motion.div {...fadeSlideIn}>
          <Box className={style.proposalMainD}>
            <form
              onSubmit={handleCustomSubmit}
              autoComplete="false"
              autoSave="false"
            >
              <Grid container spacing={2}>
                <Grid size={{xs: 12}}>
                  {selectedClient !== null ? (
                    <div className={style.client_title}>
                      <p> On behalf of Client : </p>
                      <Stack
                        sx={{pb: 2, pt: 1}}
                        direction="row"
                        alignItems="center"
                        spacing={1}
                      >
                        <h3>
                          {selectedClient?.first_name}{" "}
                          {selectedClient?.last_name}{" "}
                        </h3>
                        {proposal_id ? null : (
                          <Button
                            variant="outlined"
                            type="button"
                            onClick={() => {
                              navigate("/clients");
                              // navigate('/client-select')
                              dispatch(
                                setAuthData({
                                  selectedClient: null,
                                })
                              );
                            }}
                          >
                            <IoIosClose />
                          </Button>
                        )}
                      </Stack>

                      {/* <span>{selectedClient?.email} </span> */}
                      <Divider />
                    </div>
                  ) : null}

                  <h1 className={style.propo_title}>Business Details</h1>

                  <h2 className={style.formTitleh2}>1) Personal Details</h2>
                </Grid>

                <Grid size={{xs: 12, md: 12}}>
                  <h3 className={style.htitleText}>
                    Our firm or Corporation name is *
                  </h3>
                </Grid>

                <Grid size={{xs: 12, md: 12, xl: 10}}>
                  <GlobalTextField
                    type="text"
                    value={formik.values.firm_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    id="firm_name"
                    name="firm_name"
                    error={
                      formik.touched.firm_name &&
                      Boolean(formik.errors.firm_name)
                    }
                    helperText={
                      formik.touched.firm_name && formik.errors.firm_name
                    }
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2}>
                <Grid size={{xs: 12, md: 12, sm: 12, xl: 10}} sx={{mt: 1}}>
                  <Grid container spacing={2}>
                    <Grid size={{xs: 12, md: 12}} sx={{mt: 2}}>
                      <h3 className={style.htitleText}>
                        {/* Names of individual members * */}
                        Names of Individual Members or Officers of our firm are
                        *
                      </h3>
                    </Grid>
                    <Grid size={{xs: 12, md: 12}}>
                      <GlobalMultiTextField
                        id="owner_name"
                        name="owner_name"
                        onBlur={formik.handleBlur}
                        maxValues={maxValues}
                        error={
                          formik.values.owner_name?.length > 19 ||
                          (formik.touched.owner_name &&
                            Boolean(formik.errors.owner_name))
                        }
                        helperText={
                          formik.touched.owner_name && formik.errors.owner_name
                        }
                        values={formik.values.owner_name}
                        onChange={(newValues) =>
                          formik.setFieldValue("owner_name", newValues)
                        }
                      />

                      {/* <GlobalTextField
                        type="text"
                        value={formik.values.owner_name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        id="owner_name"
                        name="owner_name"
                        error={
                          formik.touched.owner_name &&
                          Boolean(formik.errors.owner_name)
                        }
                        helperText={
                          formik.touched.owner_name && formik.errors.owner_name
                        }
                      /> */}
                    </Grid>
                  </Grid>
                </Grid>

                {/* <Grid
                  size={{ xs: 12, xl: 6, sm: 6, md: 6, xl: 5 }}
                  sx={{ mt: { md: 3, sm: 3, xs: 0 } }}
                >
                  <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 12 }}>
                      <h3 className={style.htitleText}>
                        Officers of our firm are *
                      </h3>
                    </Grid>
                    <Grid size={{ xs: 12, md: 12 }}>
                      <GlobalMultiTextField
                        id="officer_name"
                        name="officer_name"
                        onBlur={formik.handleBlur}
                        maxValues={maxValues}
                        error={
                          formik.values.officer_name?.length > 19 ||
                          (formik.touched.officer_name &&
                            Boolean(formik.errors.officer_name))
                        }
                        helperText={
                          formik.touched.officer_name &&
                          formik.errors.officer_name
                        }
                        values={formik.values.officer_name}
                        onChange={(newValues) =>
                          formik.setFieldValue("officer_name", newValues)
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid> */}
                <Grid size={{xs: 12, md: 6, sm: 6, xl: 5}}>
                  <Grid container spacing={2}>
                    <Grid size={{xs: 12, md: 12}}>
                      <h3 className={style.htitleText}>Street *</h3>
                    </Grid>
                    <Grid size={{xs: 12, md: 12}}>
                      <GlobalTextField
                        type="text"
                        value={formik.values.street}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        id="street"
                        name="street"
                        error={
                          formik.touched.street && Boolean(formik.errors.street)
                        }
                        helperText={
                          formik.touched.street && formik.errors.street
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid size={{xs: 12, xl: 6, sm: 6, md: 6, xl: 5}}>
                  <Grid container spacing={2}>
                    <Grid size={{xs: 12, md: 12}}>
                      <div className={style.plusIconMain}>
                        <h3 className={style.htitleText}>
                          Suite / Apartment / Unit #
                        </h3>

                        <div
                            className={style.plusImgMain + " " + style.plusImgWidth}
                          >
                            {/* Add Icon - Show only at index 0 and if the limit is not exceeded */}
                            {/* {formik.values.goods_in_the_custody.length <
                              propertyOutsideLimit && ( */}
                              <p
                                style={{
                                  position: "inherit",
                                  display: "flex",
                                }}
                                onClick={handleMultipleAddress}
                              >
                                <img
                                  src={plusIcon}
                                  alt="Add"
                                  style={{marginRight: "5px"}}
                                />
                                Add
                              </p>
                              {/* )} */}
                          </div>
                        </div>
                    </Grid>
                    <Grid size={{xs: 12, md: 12}}>
                      <GlobalTextField
                        type="text"
                        value={formik.values.suite}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        id="suite"
                        name="suite"
                        error={
                          formik.touched.suite && Boolean(formik.errors.suite)
                        }
                        helperText={formik.touched.suite && formik.errors.suite}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid size={{xs: 12, md: 4, sm: 4, lg: 4, xl: 3.33}}>
                  <Grid container spacing={2}>
                    <Grid size={{xs: 12, md: 12}}>
                      <h3 className={style.htitleText}>City *</h3>
                    </Grid>
                    <Grid size={{xs: 12, md: 12}}>
                      <GlobalTextField
                        type="text"
                        value={formik.values.city}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        id="city"
                        name="city"
                        error={
                          formik.touched.city && Boolean(formik.errors.city)
                        }
                        helperText={formik.touched.city && formik.errors.city}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid size={{xs: 12, md: 4, sm: 4, lg: 4, xl: 3.33}}>
                  <Grid container spacing={2}>
                    <Grid size={{xs: 12, md: 12}}>
                      <h3 className={style.htitleText}>State *</h3>
                    </Grid>
                    <Grid size={{xs: 12, md: 12}}>
                      <GlobalTextField
                        type="text"
                        value={formik.values.state}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        id="state"
                        name="state"
                        error={
                          formik.touched.state && Boolean(formik.errors.state)
                        }
                        helperText={formik.touched.state && formik.errors.state}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid size={{xs: 12, md: 4, sm: 4, lg: 4, xl: 3.33}}>
                  <Grid container spacing={2}>
                    <Grid size={{xs: 12, md: 12}}>
                      <h3 className={style.htitleText}>Zip *</h3>
                    </Grid>
                    <Grid size={{xs: 12, md: 12}}>
                      <GlobalTextField
                        type="text"
                        value={formik.values.zip_code}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        id="zip_code"
                        name="zip_code"
                        error={
                          formik.touched.zip_code &&
                          Boolean(formik.errors.zip_code)
                        }
                        helperText={
                          formik.touched.zip_code && formik.errors.zip_code
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid size={{xs: 12, md: 4, sm: 4, lg: 4, xl: 3.33}}>
                  <Grid container spacing={2}>
                    
                  </Grid>
                </Grid>

{formik.values.additional_addresses.map((address, index) => (
  <React.Fragment key={index}>
          {/* <Grid size={{ xs: 12 }}>
            <hr />
            <h3>Additional Address #{index + 2}</h3>
          </Grid> */}
          <Box sx={{width: "100%", mt: 0, mb:1}}>
            <Divider sx={{position: "relative"}}>
              <Chip
                label={`${index + 1}`}
                size="medium"
                clickable
                onDelete={() => removeAddress(index)}
              />
            </Divider>
          </Box>

          <Grid size={{xs: 12, md: 6, sm: 6, xl: 5}}>
            <Grid container spacing={2}>
              <Grid size={{xs: 12, md: 12}}>
                <h3 className={style.htitleText}>Street *</h3>
              </Grid>
              <Grid size={{xs: 12, md: 12}}>
                <GlobalTextField
                  type="text"
                  value={address.street}
                    onChange={(e) =>
                    formik.setFieldValue(
                      `additional_addresses[${index}].street`,
                      e.target.value
                    )
                  }
                  onBlur={() =>
                    formik.setFieldTouched(
                      `additional_addresses[${index}].street`,
                      true
                    )
                  }
                  error={
                    !!(
                      formik.touched.additional_addresses?.[index]?.street &&
                      formik.errors.additional_addresses?.[index]?.street
                    )
                  }
                  helperText={
                    formik.touched.additional_addresses?.[index]?.street
                      ? formik.errors.additional_addresses?.[index]?.street
                      : ""
                  }
                  placeH="Street"
                  
                 
                />
              </Grid>
            </Grid>
          </Grid>
          {/* <Grid size={{ xs: 12, md: 6 }}>
            <GlobalTextField
              type="text"
              value={address.street}
              onChange={(e) =>
                formik.setFieldValue(
                  `additional_addresses[${index}].street`,
                  e.target.value
                )
              }
              placeH="Street"
            />
          </Grid> */}
          <Grid size={{xs: 12, xl: 6, sm: 6, md: 6, xl: 5}}>
              <Grid container spacing={2}>
                <Grid size={{xs: 12, md: 12}}>
                    <h3 className={style.htitleText}>
                      Suite / Apartment / Unit #
                    </h3>
                </Grid>
                <Grid size={{xs: 12, md: 12}}>
                  <GlobalTextField
                    type="text"
                    value={address.suite}
                    onChange={(e) =>
                      formik.setFieldValue(
                        `additional_addresses[${index}].suite`,
                        e.target.value
                      )
                    }
                    onBlur={() =>
                      formik.setFieldTouched(
                        `additional_addresses[${index}].suite`,
                        true
                      )
                    }
                    error={
                      !!(
                        formik.touched.additional_addresses?.[index]?.suite &&
                        formik.errors.additional_addresses?.[index]?.suite
                      )
                    }
                    helperText={
                      formik.touched.additional_addresses?.[index]?.suite
                        ? formik.errors.additional_addresses?.[index]?.suite
                        : ""
                    }
                    placeH="Suite / Apartment / Unit #"
                  />
                </Grid>
              </Grid>
            </Grid>
    {/* <Grid size={{ xs: 12, md: 6 }}>
      <GlobalTextField
        type="text"
        value={address.suite}
        onChange={(e) =>
          formik.setFieldValue(
            `additional_addresses[${index}].suite`,
            e.target.value
          )
        }
        placeH="Suite / Apartment / Unit #"
      />
    </Grid> */}

        <Grid size={{xs: 12, md: 4, sm: 4, lg: 4, xl: 3.33}}>
          <Grid container spacing={2}>
            <Grid size={{xs: 12, md: 12}}>
              <h3 className={style.htitleText}>City *</h3>
            </Grid>
            <Grid size={{xs: 12, md: 12}}>
              <GlobalTextField
                type="text"
                value={address.city}
                onChange={(e) =>
                  formik.setFieldValue(
                    `additional_addresses[${index}].city`,
                    e.target.value
                  )}
                
                onBlur={() =>
                    formik.setFieldTouched(
                      `additional_addresses[${index}].city`,
                      true
                    )
                  }
                  error={
                    !!(
                      formik.touched.additional_addresses?.[index]?.city &&
                      formik.errors.additional_addresses?.[index]?.city
                    )
                  }
                  helperText={
                    formik.touched.additional_addresses?.[index]?.city
                      ? formik.errors.additional_addresses?.[index]?.city
                      : ""
                  }
                  placeH="City"
                
              />
            </Grid>
          </Grid>
        </Grid>

    {/* <Grid size={{ xs: 12, md: 4 }}>
      <GlobalTextField
        type="text"
        value={address.city}
        onChange={(e) =>
          formik.setFieldValue(
            `additional_addresses[${index}].city`,
            e.target.value
          )
        }
        placeH="City"
      />
    </Grid> */}

    <Grid size={{xs: 12, md: 4, sm: 4, lg: 4, xl: 3.33}}>
                  <Grid container spacing={2}>
                    <Grid size={{xs: 12, md: 12}}>
                      <h3 className={style.htitleText}>State *</h3>
                    </Grid>
                    <Grid size={{xs: 12, md: 12}}>
                      <GlobalTextField
                        type="text"
                        value={address.state}
                        onChange={(e) =>
                          formik.setFieldValue(
                            `additional_addresses[${index}].state`,
                            e.target.value
                          )
                        }
                        onBlur={() =>
                          formik.setFieldTouched(
                            `additional_addresses[${index}].state`,
                            true
                          )
                        }
                        error={
                          !!(
                            formik.touched.additional_addresses?.[index]?.state &&
                            formik.errors.additional_addresses?.[index]?.state
                          )
                        }
                        helperText={
                          formik.touched.additional_addresses?.[index]?.state
                            ? formik.errors.additional_addresses?.[index]?.state
                            : ""
                        }
                        placeH="State"
                      />
                    </Grid>
                  </Grid>
                </Grid>

    {/* <Grid size={{ xs: 12, md: 4 }}>
      <GlobalTextField
        type="text"
        value={address.state}
        onChange={(e) =>
          formik.setFieldValue(
            `additional_addresses[${index}].state`,
            e.target.value
          )
        }
        placeH="State"
      />
    </Grid> */}


<Grid size={{xs: 12, md: 4, sm: 4, lg: 4, xl: 3.33}}>
                  <Grid container spacing={2}>
                    <Grid size={{xs: 12, md: 12}}>
                      <h3 className={style.htitleText}>Zip *</h3>
                    </Grid>
                    <Grid size={{xs: 12, md: 12}}>
                      <GlobalTextField
                        type="text"
                        value={address.zip_code}
                        onChange={(e) =>
                          formik.setFieldValue(
                            `additional_addresses[${index}].zip_code`,
                            e.target.value
                          )
                        }
                        onBlur={() =>
                          formik.setFieldTouched(
                            `additional_addresses[${index}].zip_code`,
                            true
                          )
                        }
                        error={
                          !!(
                            formik.touched.additional_addresses?.[index]?.zip_code &&
                            formik.errors.additional_addresses?.[index]?.zip_code
                          )
                        }
                        helperText={
                          formik.touched.additional_addresses?.[index]?.zip_code
                            ? formik.errors.additional_addresses?.[index]?.zip_code
                            : ""
                        }
                        placeH="Zip"
                      />
                    </Grid>
                  </Grid>
                </Grid>
    {/* <Grid size={{ xs: 12, md: 3 }}>
      <GlobalTextField
        type="text"
        value={address.zip_code}
        onChange={(e) =>
          formik.setFieldValue(
            `additional_addresses[${index}].zip_code`,
            e.target.value
          )
        }
        placeH="Zip"
      />
    </Grid> */}

    {/* <Grid size={{ xs: 12, md: 1 }}>
      <Button
        color="error"
        type="button"
        onClick={() => removeAddress(index)}
      >
        X
      </Button>
    </Grid> */}
  </React.Fragment>
))}
                {/* <Grid size={{xs: 12, md: 12}}>
                  <h3 className={style.htitleText}>
                    Our premises are located at (floor) *
                  </h3>
                </Grid>

                <Grid size={{xs: 12, md: 12, xl: 10}}>
                  <GlobalTextField
                    type="text"
                    value={formik.values.address}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    id="address"
                    name="address"
                    error={
                      formik.touched.address && Boolean(formik.errors.address)
                    }
                    helperText={formik.touched.address && formik.errors.address}
                  />
                </Grid> */}
              </Grid>

              <Grid container spacing={2}>
                <Grid size={{xs: 12, md: 6, xl: 5}} sx={{mt: 1}}>
                  <Grid container spacing={1}>
                    <Grid size={{xs: 12, md: 12}} sx={{mt: 2, mb: 1}}>
                      <h3 className={style.htitleText}>
                        How long have you carried on business here? *
                      </h3>
                    </Grid>
                    <Grid size={{xs: 12, md: 12}}>
                      {/* <GlobalTextField
                        type="number"
                        placeH={"Number of Months Only."}
                        value={formik.values.business_duration}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        id="business_duration"
                        name="business_duration"
                        error={
                          formik.touched.business_duration &&
                          Boolean(formik.errors.business_duration)
                        }
                        helperText={
                          formik.touched.business_duration &&
                          formik.errors.business_duration
                        }
                      /> */}
                      <GlobalYearMonthField
                        // value={
                        //   dayjs(
                        //     formik.values.business_duration,
                        //     "MMMM YYYY"
                        //   ).toDate() || null
                        // }
                        value={
                          formik.values.business_duration
                            ? dayjs(
                                formik.values.business_duration,
                                "MMMM YYYY"
                              ).toDate()
                            : null
                        }
                        // value={formik.values.business_duration || null}
                        onChange={(newValue) => {
                          formik.setFieldValue(`business_duration`, newValue);
                        }}
                        onBlur={() =>
                          formik.setFieldTouched(`business_duration`, true)
                        }
                        id="business_duration"
                        name="business_duration"
                        error={
                          formik.touched.business_duration &&
                          Boolean(formik.errors.business_duration)
                        }
                        helperText={
                          formik.touched.business_duration &&
                          formik.errors.business_duration
                        }
                        clearBtn={formik.values.business_duration !== ""}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid size={{xs: 12, md: 6, xl: 5}} sx={{mt: {md: 3, xs: 1}}}>
                  <Grid container spacing={1}>
                    <Grid size={{xs: 12, md: 12}} sx={{mb: 1}}>
                      <h3 className={style.htitleText}>Elsewhere?</h3>
                    </Grid>
                    <Grid size={{xs: 12, md: 12}}>
                      {/* <GlobalTextField
                        placeH={"0 if None."}
                        type="number"
                        value={formik.values.elsewhere_duration}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        id="elsewhere_duration"
                        name="elsewhere_duration"
                        error={
                          formik.touched.elsewhere_duration &&
                          Boolean(formik.errors.elsewhere_duration)
                        }
                        helperText={
                          formik.touched.elsewhere_duration &&
                          formik.errors.elsewhere_duration
                        }
                      /> */}
                      <GlobalYearMonthField
                        value={
                          formik.values.elsewhere_duration
                            ? dayjs(
                                formik.values.elsewhere_duration,
                                "MMMM YYYY"
                              ).toDate()
                            : null
                        }
                        // value={formik.values.elsewhere_duration || null}
                        onChange={(newValue) =>
                          formik.setFieldValue(`elsewhere_duration`, newValue)
                        }
                        onBlur={() =>
                          formik.setFieldTouched(`elsewhere_duration`, true)
                        }
                        id="elsewhere_duration"
                        name="elsewhere_duration"
                        error={
                          formik.touched.elsewhere_duration &&
                          Boolean(formik.errors.elsewhere_duration)
                        }
                        helperText={
                          formik.touched.elsewhere_duration &&
                          formik.errors.elsewhere_duration
                        }
                        clearBtn={formik.values.elsewhere_duration !== ""}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{mt: 1}}>
                <Grid size={{xs: 12, md: 12}} sx={{mt: 2}}>
                  <h2 className={style.formTitleh2}>
                    2) Nature of our Business
                  </h2>
                </Grid>
                {["Manufacturing", "Retail", "Wholesale", "Pawnbroking"].map(
                  (field) => (
                    <Grid
                      size={{xs: 12, md: 3, lg: 3, sm: 6, xl: 2.5}}
                      key={field}
                    >
                      <FormControl fullWidth>
                        <FormLabel className={style.labelText} sx={{mb: 1}}>
                          {/* {field}% */}
                          {field} * (%)
                        </FormLabel>
                        <GlobalTextField
                          placeH="%"
                          type="text"
                          id={field?.toLowerCase()}
                          name={field?.toLowerCase()}
                          value={formik.values?.[field?.toLowerCase()]}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched?.[field?.toLowerCase()] &&
                            Boolean(formik.errors?.[field?.toLowerCase()])
                          }
                          helperText={
                            formik.touched?.[field?.toLowerCase()] &&
                            formik.errors?.[field?.toLowerCase()]
                          }
                        />
                      </FormControl>
                    </Grid>
                  )
                )}
              </Grid>

              <Grid container spacing={2}>
                <Grid
                  size={{xs: 12, md: 12}}
                  sx={{mt: {xl: 3, lg: 2, md: 3, xs: 2}}}
                >
                  <h2 className={style.formTitleh2}>3) Employees</h2>
                </Grid>
                <Grid size={{xs: 12, xl: 6, md: 6, lg: 6, xl: 5}}>
                  <Grid container spacing={1}>
                    <Grid size={{xs: 12, md: 12}} sx={{mb: 1}}>
                      <h3 className={style.htitleText}>
                        Number of Employees *
                      </h3>
                    </Grid>
                    <Grid size={{xs: 12, md: 12}}>
                      <GlobalTextField
                        type="number"
                        id="no_of_employees"
                        name="no_of_employees"
                        value={formik.values?.no_of_employees}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched?.no_of_employees &&
                          Boolean(formik.errors?.no_of_employees)
                        }
                        helperText={
                          formik.touched?.no_of_employees &&
                          formik.errors?.no_of_employees
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid size={{xs: 12, xl: 6, md: 6, lg: 6, xl: 5}}>
                  <Grid container spacing={1}>
                    <Grid size={{xs: 12, md: 12}} sx={{mb: 1}}>
                      <h3 className={style.htitleText}>
                        Minimum number on Premises during business hours *
                      </h3>
                    </Grid>
                    <Grid size={{xs: 12, md: 12}}>
                      <GlobalTextField
                        type="number"
                        id="office_hours"
                        name="office_hours"
                        value={formik.values?.office_hours}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched?.office_hours &&
                          Boolean(formik.errors?.office_hours)
                        }
                        helperText={
                          formik.touched?.office_hours &&
                          formik.errors?.office_hours
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </form>
          </Box>
        </motion.div>
        <NewProposalFooter
          submitForm={handleCustomSubmit}
          leftGridWidth={leftGridWidth}
          nextPage={
            previous_proposal_id
              ? false
              : areRequiredFieldsFilled(formik) &&
                !formik.dirty &&
                propStep1DataMemoize !== null
          }
          handleSaveDraft={handleSaveDraft}
          disableDraft={disableDraft}
        />
      </section>
    </>
  );
};

export default StepOneForm;
